import {
  Heading,
  Button,
  Image,
  Flex,
  Box,
  Text,
  Container,
} from "@chakra-ui/react";
import resume from "../Images/Sachin_Kesarwani_Resume.pdf";
import React from "react";
import mypic from "./mypic.jpg";
import { BiArrowToBottom } from "react-icons/bi";
import "./about.css";
import { redirect } from "../utils";
const About = () => {

  return (
    <div>
      <div id="about" class="about section" style={{ paddingTop: "120px" }}>
        <div id="imageDiv" style={{ backgroundColor: "black" }}>
          <img className="home-img" src={mypic} />
        </div>
        <div
          style={{
            borderRadius: "30px",
            backgroundColor: "black",
            border: "1px solid #2e9b56",
            boxShadow:"0 0 3px 2px rgba(0, 255, 0, 0.5)"
          }}
        >
          <Heading style={{ margin: "20px" }} color={"white"}>
            About
          </Heading>
          {/* <Heading color={"blue.600"} id="user-detail-name">
            Hi , I am Sachin Kesarwani
            <Heading>
              <img
                style={{ margin: "auto" }}
                src="https://readme-typing-svg.demolab.com?font=Fira+Code&size=30&pause=1000&color=BC3131&background=FFFFFF3B&width=435&lines=Full+Stack+Web+Developer"
                alt="Typing SVG"
              />
            </Heading>
          </Heading> */}
          <Container maxW="md" color="white">
            <Text textAlign={"justify"} fontSize={"lg"} id="user-detail-intro">
              {/* Highly motivated and eager to learn new things.
Hard-working , creative , proactive , and specialized in HTML , CSS ,JavaScript and Javascript framework
React JS for frontend  and MongoDB , ExpressJS and NodeJS for  backend.  Keep improving skill day by day.
Ability to adapt in both self-starting and collaborative
environments. */}
              Full Stack Developer with experience at Traviez, specializing in
              frontend development and certified by Masai School. Proficient in
              web and mobile application development, focused on delivering
              seamless user experiences and optimizing performance. Skilled in
              crafting innovative solutions, collaborating in cross-functional
              teams, and adapting to dynamic project requirements
            </Text>
          </Container>

          <a
            href={resume}
            id="resume-link-2"
            target="_blank"
            download="Sachin-Kesarwani.pdf"
          >
            <Button
              boxShadow="0 0 3px 3px rgba(0, 255, 0, 0.5)"
              style={{ position: "static", marginTop: "20px" }}
              onClick={redirect}
              bg="black"
              _hover={{ bg: "#2e9b56", color: "white" }}
              color="#2e9b56"
              border={"2px solid #2e9b56"}
              id="resume-button-2"
            >
              Resume <BiArrowToBottom fontSize={"20px"} color={"green.600"} />
            </Button>
          </a>
        </div>
      </div>
    </div>
  );
};

export default About;
